import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["data-feature-key"]
const _hoisted_2 = ["src", "alt", "aria-hidden"]
const _hoisted_3 = { class: "feature-mosaic-card__main-copy" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "feature-mosaic-card__size"
}
const _hoisted_6 = {
  key: 0,
  class: "feature-mosaic-card__photo-copy"
}
const _hoisted_7 = { class: "feature-mosaic-card__photo-value" }
const _hoisted_8 = {
  key: 1,
  class: "feature-mosaic-card__image-copy"
}
const _hoisted_9 = {
  key: 0,
  class: "feature-mosaic-card__badge"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "feature-mosaic-card__text" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 0,
  class: "feature-mosaic-card__icon feature-mosaic-card__icon--route",
  "aria-hidden": "true"
}
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 1,
  viewBox: "0 0 64 64",
  fill: "none"
}
const _hoisted_18 = {
  key: 2,
  viewBox: "0 0 64 64",
  fill: "none"
}
const _hoisted_19 = {
  key: 3,
  viewBox: "0 0 64 64",
  fill: "none"
}
const _hoisted_20 = {
  key: 4,
  viewBox: "0 0 64 64",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "48",
  height: "48",
  customFrame: "#000000"
}
const _hoisted_21 = {
  key: 5,
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "48",
  height: "48",
  viewBox: "0 0 64 64",
  fill: "none"
}
const _hoisted_22 = {
  key: 0,
  class: "feature-mosaic-card__metric-panel"
}
const _hoisted_23 = { class: "feature-mosaic-card__metric-value" }
const _hoisted_24 = {
  key: 1,
  class: "feature-mosaic-card__icon feature-mosaic-card__icon--battery",
  "aria-hidden": "true"
}
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none"
}
const _hoisted_27 = { class: "feature-mosaic-card__stat-value" }
const _hoisted_28 = {
  key: 0,
  class: "feature-mosaic-card__stat-value-suffix"
}
const _hoisted_29 = {
  key: 0,
  class: "feature-mosaic-card__icon feature-mosaic-card__icon--stats",
  "aria-hidden": "true"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 1,
  viewBox: "0 0 24 24",
  fill: "none"
}

import { computed } from 'vue'
import type { FeatureMosaicItem } from './featureMosaic'


export default /*@__PURE__*/_defineComponent({
  __name: 'FeatureMosaicCard',
  props: {
    item: {},
    compact: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const imageAlt = computed(() => props.item.imageAlt || props.item.alt || '')

const cardClass = computed(() => [
  'feature-mosaic-card',
  `feature-mosaic-card--${props.item.variant}`,
  props.item.tone ? `feature-mosaic-card--${props.item.tone}` : '',
  props.item.group ? `feature-mosaic-card--group-${props.item.group}` : '',
  props.compact ? 'feature-mosaic-card--compact' : ''
])

const cardStyle = computed(() => ({
  '--feature-mosaic-image-position': props.item.imagePosition || 'center',
  '--feature-mosaic-image-fit': props.item.imageFit || 'cover',
  '--feature-mosaic-card-min-height': props.item.minHeight || ''
}))

const getStatValueParts = (value: string) => {
  const match = value.match(/^(.+?)([（(][^）)]*[）)])$/)

  if (!match) {
    return {
      main: value,
      suffix: ''
    }
  }

  return {
    main: match[1].trim(),
    suffix: match[2]
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(cardClass.value),
    style: _normalizeStyle(cardStyle.value),
    "data-feature-key": _ctx.item.key
  }, [
    (_ctx.item.image)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "feature-mosaic-card__media",
          src: _ctx.item.image,
          alt: imageAlt.value,
          "aria-hidden": imageAlt.value ? undefined : 'true',
          loading: "lazy"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.item.variant === 'hero')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.item.title)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_ctx.item.title), 1))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.tags, (tag) => {
              return (_openBlock(), _createElementBlock("p", { key: tag }, _toDisplayString(tag), 1))
            }), 128))
          ]),
          (_ctx.item.footnote)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("p", null, _toDisplayString(_ctx.item.footnote.value), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.item.footnote.label), 1)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_ctx.item.variant === 'image')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.item.metric)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.item.metric.value), 1),
                  _createElementVNode("span", null, _toDisplayString(_ctx.item.metric.label), 1)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_ctx.item.badge)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.item.badge), 1))
                    : _createCommentVNode("", true),
                  (_ctx.item.title)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_10, _toDisplayString(_ctx.item.title), 1))
                    : _createCommentVNode("", true),
                  (_ctx.item.description || _ctx.item.subtitle)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.item.description || _ctx.item.subtitle), 1))
                    : _createCommentVNode("", true)
                ]))
          ], 64))
        : (_ctx.item.variant === 'action')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("div", _hoisted_12, [
                (_ctx.item.title)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_13, _toDisplayString(_ctx.item.title), 1))
                  : _createCommentVNode("", true),
                (_ctx.item.description || _ctx.item.subtitle)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.item.description || _ctx.item.subtitle), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.item.icon || _ctx.item.iconSrc)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                    (_ctx.item.iconSrc)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          class: "feature-mosaic-card__icon-image",
                          src: _ctx.item.iconSrc,
                          alt: "",
                          loading: "lazy"
                        }, null, 8, _hoisted_16))
                      : (_ctx.item.icon === 'route')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_17, _cache[0] || (_cache[0] = [
                            _createElementVNode("path", {
                              d: "M11 48c9-13 17-22 31-30 4-2 8-4 13-5",
                              stroke: "currentColor",
                              "stroke-width": "4",
                              "stroke-linecap": "round"
                            }, null, -1),
                            _createElementVNode("path", {
                              d: "m46 10 10 2-4 10",
                              stroke: "currentColor",
                              "stroke-width": "4",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, null, -1),
                            _createElementVNode("circle", {
                              cx: "17",
                              cy: "46",
                              r: "4",
                              fill: "currentColor"
                            }, null, -1),
                            _createElementVNode("circle", {
                              cx: "34",
                              cy: "28",
                              r: "4",
                              fill: "currentColor"
                            }, null, -1)
                          ])))
                        : (_ctx.item.icon === 'semantic')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_18, _cache[1] || (_cache[1] = [
                              _createStaticVNode("<circle cx=\"32\" cy=\"32\" r=\"26\" stroke=\"currentColor\" stroke-width=\"4\" data-v-a70fc5cc></circle><circle cx=\"22\" cy=\"22\" r=\"5\" fill=\"currentColor\" data-v-a70fc5cc></circle><circle cx=\"42\" cy=\"22\" r=\"5\" fill=\"currentColor\" data-v-a70fc5cc></circle><circle cx=\"32\" cy=\"43\" r=\"5\" fill=\"currentColor\" data-v-a70fc5cc></circle><path d=\"M25 25l7 14 7-14\" stroke=\"currentColor\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-a70fc5cc></path>", 5)
                            ])))
                          : (_ctx.item.icon === 'sdk')
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_19, _cache[2] || (_cache[2] = [
                                _createElementVNode("rect", {
                                  x: "11",
                                  y: "10",
                                  width: "42",
                                  height: "44",
                                  rx: "8",
                                  stroke: "currentColor",
                                  "stroke-width": "4"
                                }, null, -1),
                                _createElementVNode("path", {
                                  d: "M22 24h20M22 34h20M22 44h20",
                                  stroke: "currentColor",
                                  "stroke-width": "4",
                                  "stroke-linecap": "round"
                                }, null, -1),
                                _createElementVNode("path", {
                                  d: "M18 18h28M18 54h28",
                                  stroke: "currentColor",
                                  "stroke-width": "4",
                                  "stroke-linecap": "round"
                                }, null, -1)
                              ])))
                            : (_ctx.item.icon === 'text-scan')
                              ? (_openBlock(), _createElementBlock("svg", _hoisted_20, _cache[3] || (_cache[3] = [
                                  _createElementVNode("path", {
                                    id: "矢量 16",
                                    d: "M16.3533 3.17891e-06C16.6851 -0.000603994 17.0096 0.0978374 17.2851 0.28272C17.5606 0.467602 17.7747 0.730514 17.8999 1.03779C18.0251 1.34507 18.0557 1.68271 17.9878 2.0075C17.92 2.33229 17.7567 2.62944 17.519 2.86089C17.2812 3.09234 16.9798 3.24756 16.6533 3.30667L16.3533 3.33334L7.5 3.33334C6.81664 3.33302 6.1437 3.50079 5.54046 3.82186C4.93723 4.14292 4.42221 4.60742 4.04081 5.17444C3.6594 5.74145 3.42331 6.39357 3.35333 7.07334L3.33334 7.5L3.33334 16.3867C3.33395 16.7185 3.23551 17.0429 3.05062 17.3184C2.86574 17.5939 2.60283 17.808 2.29555 17.9332C1.98828 18.0584 1.65063 18.089 1.32584 18.0212C1.00105 17.9533 0.703907 17.7901 0.472457 17.5523C0.241006 17.3146 0.0857862 17.0132 0.0266711 16.6867L3.17891e-06 16.3867L3.17891e-06 7.5C-0.000155767 6.2414 0.316432 5.003 0.920594 3.89889C1.52475 2.79478 2.39706 1.86046 3.45715 1.18202C4.51724 0.503572 5.73102 0.102816 6.98667 0.0166702L7.5 3.17891e-06L16.3533 3.17891e-06L16.3533 3.17891e-06ZM42.5 3.17891e-06C43.7586 -0.000149409 44.997 0.316439 46.1011 0.920601C47.2052 1.52476 48.1395 2.39707 48.818 3.45715C49.4964 4.51724 49.8972 5.73102 49.9833 6.98667L50 7.5L50 16.5667C49.9999 16.8982 49.901 17.2223 49.7158 17.4973C49.5306 17.7723 49.2676 17.9859 48.9604 18.1106C48.6531 18.2354 48.3157 18.2656 47.9912 18.1976C47.6667 18.1295 47.3698 17.9662 47.1386 17.7285C46.9074 17.4908 46.7524 17.1896 46.6933 16.8633L46.6667 16.5633L46.6667 7.5C46.667 6.81665 46.4992 6.1437 46.1781 5.54047C45.8571 4.93723 45.3926 4.42222 44.8256 4.04081C44.2585 3.65941 43.6064 3.42332 42.9267 3.35334L42.5 3.33334L34.07 3.33334C33.7382 3.33394 33.4138 3.2355 33.1382 3.05062C32.8627 2.86574 32.6487 2.60282 32.5235 2.29555C32.3983 1.98827 32.3676 1.65063 32.4355 1.32584C32.5033 1.00105 32.6666 0.703904 32.9043 0.472453C33.1421 0.241003 33.4435 0.085783 33.77 0.0266711L34.07 3.17891e-06L42.5 3.17891e-06ZM48.3333 32.3833C48.5919 32.3832 48.847 32.4433 49.0783 32.5588C49.3097 32.6744 49.511 32.8421 49.6664 33.0488C49.8217 33.2556 49.9268 33.4956 49.9733 33.75L50 34.05L50 42.5C50.0001 43.7586 49.6836 44.997 49.0794 46.1011C48.4752 47.2052 47.6029 48.1395 46.5428 48.818C45.4828 49.4964 44.269 49.8972 43.0133 49.9833L42.5 50L33.8933 50C33.5615 50.0006 33.2371 49.9022 32.9616 49.7173C32.6861 49.5324 32.472 49.2695 32.3468 48.9622C32.2216 48.6549 32.191 48.3173 32.2588 47.9925C32.3267 47.6677 32.4899 47.3706 32.7277 47.1391C32.9654 46.9077 33.2668 46.7524 33.5933 46.6933L33.8933 46.6667L42.5 46.6667C43.1834 46.667 43.8563 46.4992 44.4595 46.1782C45.0628 45.8571 45.5778 45.3926 45.9592 44.8256C46.3406 44.2585 46.5767 43.6064 46.6467 42.9267L46.6667 42.5L46.6667 34.05C46.6667 33.7574 46.7437 33.47 46.89 33.2167C47.0362 32.9633 47.2466 32.7529 47.5 32.6066C47.7534 32.4603 48.0408 32.3833 48.3333 32.3833L48.3333 32.3833ZM1.66667 32.0467C1.92526 32.0466 2.18033 32.1067 2.41169 32.2222C2.64304 32.3377 2.84436 32.5054 2.99969 32.7122C3.15502 32.9189 3.26012 33.159 3.30667 33.4133L3.33333 33.7133L3.33333 42.5C3.33333 44.6567 4.97333 46.4333 7.07333 46.6467L7.5 46.6667L16.3833 46.6667C16.7151 46.6661 17.0396 46.7645 17.3151 46.9494C17.5906 47.1343 17.8047 47.3972 17.9299 47.7044C18.0551 48.0117 18.0857 48.3494 18.0179 48.6742C17.95 48.999 17.7867 49.2961 17.549 49.5276C17.3113 49.759 17.0098 49.9142 16.6833 49.9733L16.3833 50L7.5 50C6.2414 50.0002 5.003 49.6836 3.89888 49.0794C2.79477 48.4752 1.86046 47.6029 1.18201 46.5428C0.503565 45.4828 0.102812 44.269 0.016667 43.0133L0 42.5L0 33.7133C0 33.4208 0.0770092 33.1334 0.22329 32.88C0.369571 32.6266 0.579967 32.4162 0.833333 32.27C1.0867 32.1237 1.3741 32.0467 1.66667 32.0467ZM37.15 38.1867C34.7955 37.3266 32.4957 36.3236 30.2633 35.1833C28.4229 34.2437 26.6886 33.1094 25.09 31.8C23.61 33.01 21.8867 34.1467 19.9167 35.2133C17.9433 36.28 15.6367 37.3167 12.9967 38.3333L11.6667 35.58C13.9189 34.8191 16.121 33.9173 18.26 32.88C19.9539 32.0615 21.5591 31.0707 23.05 29.9233C21.6374 28.4615 20.4368 26.8087 19.4833 25.0133C18.4363 23.0038 17.6093 20.8871 17.0167 18.7L12.6733 18.7L12.6733 16.0633L23.7567 16.0633C23.3907 14.7464 22.9973 13.4372 22.5767 12.1367L25.3833 11.6667C25.68 12.4467 26.1333 13.9133 26.7433 16.0633L37.3267 16.0633L37.3267 18.6967L32.8667 18.6967C32.3473 20.8851 31.5731 23.0052 30.56 25.0133C29.625 26.8247 28.4413 28.4965 27.0433 29.98C28.4433 31.0567 30.0633 32.0267 31.9067 32.8967C33.75 33.7667 35.8933 34.5933 38.3367 35.3733L37.1533 38.1867L37.15 38.1867ZM19.8833 18.7C20.4167 20.6933 21.1033 22.4667 21.94 24.0167C22.7767 25.57 23.8067 26.9533 25.03 28.1633C26.2133 26.9333 27.1967 25.5533 27.9867 24.0167C28.7733 22.4833 29.4233 20.7133 29.9367 18.7L19.8867 18.7L19.8833 18.7Z",
                                    fill: "rgb(255,255,255)",
                                    "fill-rule": "nonzero"
                                  }, null, -1)
                                ])))
                              : (_ctx.item.icon === 'sdk-platform')
                                ? (_openBlock(), _createElementBlock("svg", _hoisted_21, _cache[4] || (_cache[4] = [
                                    _createElementVNode("rect", {
                                      id: "svg 11",
                                      width: "64.000000",
                                      height: "64.000000",
                                      x: "0.000000",
                                      y: "0.000000"
                                    }, null, -1),
                                    _createElementVNode("path", {
                                      id: "矢量 24",
                                      d: "M13.6348 28.6192C15.1078 28.6192 16.3814 28.375 17.4556 27.8867C18.5298 27.3985 19.3456 26.723 19.9031 25.8603C20.4606 24.9977 20.7393 24.0252 20.7393 22.9428C20.7393 22.0395 20.5786 21.2766 20.2571 20.6541C19.9356 20.0315 19.4881 19.5168 18.9143 19.1098C18.3406 18.703 17.6448 18.3571 16.8269 18.0723C16.0091 17.7875 15.0956 17.527 14.0864 17.291C13.2808 17.0876 12.7029 16.9329 12.353 16.8272C12.0031 16.7213 11.6573 16.5748 11.3154 16.3877C10.9736 16.2005 10.7051 15.9767 10.5098 15.7163C10.3144 15.4559 10.2168 15.1467 10.2168 14.7886C10.2168 14.2108 10.5037 13.7164 11.0774 13.3055C11.6511 12.8945 12.4059 12.689 13.3418 12.689C14.3509 12.689 15.0833 12.8782 15.5391 13.2566C15.9948 13.635 16.3854 14.162 16.7109 14.8374C16.9632 15.3094 17.1972 15.6492 17.4128 15.8567C17.6285 16.0642 17.9439 16.168 18.3589 16.168C18.8146 16.168 19.1951 15.995 19.5003 15.6492C19.8054 15.3033 19.958 14.9147 19.958 14.4834C19.958 14.0114 19.8359 13.5272 19.5918 13.0308C19.3476 12.5343 18.9611 12.0603 18.4321 11.6087C17.9032 11.157 17.2379 10.7948 16.4363 10.5222C15.6347 10.2496 14.6846 10.1133 13.5859 10.1133C12.2106 10.1133 11.0143 10.3188 9.99707 10.7297C8.97982 11.1407 8.20269 11.7287 7.6655 12.4937C7.12844 13.2587 6.85988 14.1335 6.85988 15.1182C6.85988 16.1517 7.11419 17.0163 7.62282 17.7122C8.13144 18.408 8.81907 18.9573 9.68582 19.3601C10.5525 19.763 11.6288 20.1149 12.9146 20.416C13.8748 20.6357 14.6419 20.8433 15.2156 21.0385C15.7893 21.2339 16.2573 21.5167 16.6194 21.887C16.9815 22.2572 17.1626 22.7395 17.1626 23.3335C17.1626 24.0822 16.8269 24.7068 16.1555 25.2073C15.4841 25.7078 14.6113 25.958 13.5371 25.958C12.7559 25.958 12.1252 25.8339 11.645 25.5857C11.1649 25.3375 10.7926 25.0222 10.5281 24.6397C10.2636 24.2572 10.0174 23.7811 9.78957 23.2114C9.60238 22.7313 9.37656 22.3692 9.11207 22.125C8.84757 21.8808 8.52407 21.7588 8.14163 21.7588C7.66963 21.7588 7.281 21.9155 6.97582 22.2288C6.67063 22.5421 6.51807 22.9185 6.51807 23.3579C6.51807 24.1148 6.77244 24.894 7.281 25.6955C7.78963 26.4972 8.45088 27.138 9.26463 27.6182C10.4121 28.2855 11.8688 28.6192 13.6348 28.6192L13.6348 28.6192ZM30.8589 28.314C31.6808 28.314 32.4194 28.2611 33.0745 28.1552C33.7296 28.0495 34.342 27.8664 34.9116 27.606C35.4813 27.3455 36.0062 26.9997 36.4863 26.5683C37.0967 26.0068 37.5972 25.37 37.9878 24.658C38.3784 23.9459 38.6673 23.1463 38.8545 22.2593C39.0417 21.3722 39.1353 20.3916 39.1353 19.3174C39.1353 16.0622 38.2034 13.637 36.3399 12.042C35.6237 11.4153 34.8261 10.9881 33.9473 10.7603C33.0684 10.5324 32.0145 10.4184 30.7856 10.4184L26.0615 10.4184C25.2803 10.4184 24.7146 10.5934 24.3647 10.9434C24.0148 11.2933 23.8398 11.8589 23.8398 12.6402L23.8398 25.7627C23.8398 26.3405 23.8907 26.8105 23.9924 27.1727C24.0942 27.5348 24.3118 27.8155 24.6456 28.0149C24.9792 28.2143 25.4756 28.314 26.1348 28.314L30.8589 28.314ZM30.2119 25.4331L27.4653 25.4331L27.4653 13.2871L29.8579 13.2871C30.9647 13.2871 31.9087 13.4071 32.6899 13.6472C33.4712 13.8873 34.1283 14.4468 34.6614 15.3257C35.1944 16.2046 35.4609 17.527 35.4609 19.293C35.4609 21.7995 34.8547 23.5655 33.6421 24.5908C33.3736 24.8268 33.0561 25.0099 32.6899 25.1402C32.3237 25.2703 31.9698 25.3517 31.6279 25.3843C31.2861 25.4168 30.8141 25.4331 30.2119 25.4331L30.2119 25.4331ZM55.8467 28.6192C56.3838 28.6192 56.809 28.4727 57.1223 28.1797C57.4356 27.8867 57.5923 27.5408 57.5923 27.1421C57.5923 26.784 57.5028 26.4158 57.3237 26.0373C57.1447 25.659 56.8761 25.2175 56.5181 24.7129L51.44 17.4375L55.8467 13.2627C56.3919 12.7418 56.6646 12.217 56.6646 11.688C56.6646 11.2486 56.5038 10.8762 56.1824 10.5711C55.8609 10.2658 55.4397 10.1133 54.9189 10.1133C54.5202 10.1133 54.2008 10.1987 53.9607 10.3697C53.7206 10.5405 53.4297 10.805 53.0879 11.1631L45.9712 18.585L45.9712 12.3106C45.9712 11.57 45.8024 11.0187 45.4647 10.6565C45.1269 10.2943 44.6854 10.1133 44.1402 10.1133C43.5868 10.1133 43.1494 10.2964 42.8279 10.6626C42.5065 11.0288 42.3457 11.5782 42.3457 12.3105L42.3457 25.6647C42.3465 26.2107 42.3587 26.6298 42.3824 26.9223C42.4067 27.2235 42.476 27.488 42.5899 27.7158C42.7445 27.9925 42.9642 28.2122 43.2491 28.375C43.5339 28.5378 43.8309 28.6192 44.1402 28.6192C44.6773 28.6192 45.1167 28.4381 45.4586 28.0759C45.8004 27.7138 45.9712 27.1584 45.9712 26.4097L45.9712 22.7109L48.9375 19.8668L53.2222 26.4586C53.4139 26.7863 53.6092 27.1118 53.8081 27.4352C54.0278 27.7932 54.2964 28.0801 54.6138 28.2957C54.9311 28.5113 55.3421 28.6192 55.8467 28.6192L55.8467 28.6192Z",
                                      fill: "rgb(255,255,255)",
                                      "fill-rule": "nonzero"
                                    }, null, -1),
                                    _createElementVNode("path", {
                                      id: "矢量 25",
                                      d: "M52.5625 32.0625C54.0812 32.0625 55.3125 33.2938 55.3125 34.8125L55.3125 52.6875C55.3125 54.2062 54.0812 55.4375 52.5625 55.4375L10.75 55.4375C9.23125 55.4375 8 54.2062 8 52.6875L8 34.8125C8 33.2938 9.23125 32.0625 10.75 32.0625L30.0312 32.0625L30.0312 43.6506L27.175 40.7986L27.0251 40.6492C26.4131 40.0576 25.4374 40.0644 24.8338 40.6689C24.2241 41.2796 24.2248 42.2689 24.8354 42.8786L30.4687 48.5036C31.0842 49.1182 32.0831 49.1119 32.6908 48.4895L38.1825 42.8645L38.2004 42.8459C38.785 42.2272 38.7673 41.2518 38.156 40.6549C37.5385 40.0521 36.5492 40.0639 35.9464 40.6814L33.1562 43.5392L33.1562 32.0625L52.5625 32.0625Z",
                                      fill: "rgb(255,255,255)",
                                      "fill-rule": "nonzero"
                                    }, null, -1)
                                  ])))
                                : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : (_ctx.item.variant === 'metric')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                (_ctx.item.metric)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.item.metric.value), 1),
                      _createElementVNode("span", null, _toDisplayString(_ctx.item.metric.label), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.item.icon || _ctx.item.iconSrc)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                      (_ctx.item.iconSrc)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "feature-mosaic-card__icon-image",
                            src: _ctx.item.iconSrc,
                            alt: "",
                            loading: "lazy"
                          }, null, 8, _hoisted_25))
                        : (_ctx.item.icon === 'battery')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_26, _cache[5] || (_cache[5] = [
                              _createElementVNode("path", {
                                d: "M9 3h6v2h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2V3Z",
                                stroke: "currentColor",
                                "stroke-width": "1.8",
                                "stroke-linejoin": "round"
                              }, null, -1),
                              _createElementVNode("path", {
                                d: "M9 10h6M9 14h6M9 18h6",
                                stroke: "currentColor",
                                "stroke-width": "1.8",
                                "stroke-linecap": "round"
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : (_ctx.item.variant === 'stats')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.metrics, (metric) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: `${metric.value}-${metric.label}`,
                      class: "feature-mosaic-card__stat-block"
                    }, [
                      _createElementVNode("p", _hoisted_27, [
                        _createElementVNode("span", null, _toDisplayString(getStatValueParts(metric.value).main), 1),
                        (getStatValueParts(metric.value).suffix)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(getStatValueParts(metric.value).suffix), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", null, _toDisplayString(metric.label), 1)
                    ]))
                  }), 128)),
                  (_ctx.item.icon || _ctx.item.iconSrc)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                        (_ctx.item.iconSrc)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              class: "feature-mosaic-card__icon-image",
                              src: _ctx.item.iconSrc,
                              alt: "",
                              loading: "lazy"
                            }, null, 8, _hoisted_30))
                          : (_ctx.item.icon === 'battery')
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_31, _cache[6] || (_cache[6] = [
                                _createElementVNode("g", { transform: "translate(2 2) scale(0.83)" }, [
                                  _createElementVNode("path", {
                                    d: "M9 3h6v2h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2V3Z",
                                    stroke: "currentColor",
                                    "stroke-width": "1.8",
                                    "stroke-linejoin": "round"
                                  }),
                                  _createElementVNode("path", {
                                    d: "M9 10h6M9 14h6M9 18h6",
                                    stroke: "currentColor",
                                    "stroke-width": "1.8",
                                    "stroke-linecap": "round"
                                  })
                                ], -1)
                              ])))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
  ], 14, _hoisted_1))
}
}

})